/*
 * Module for the Message Center Index view
*/
rs.module("ui/content/communications/messagecenter/index",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            var filterSelect = $.js(jsSelectors.filterSelect, { required: false });
            var messageThreads = $.js(jsSelectors.messageThreads);
            var listSkeleton = $.js(jsSelectors.listSkeleton, { required: false });

            // Handle the filter select change event
            filterSelect.change(function () {
                eventBanner.removeAllMessages();

                // Show list skeleton while we load content
                listSkeleton.show();
                messageThreads.hide();

                // Retrieve message thread list and populate the partial view
                $.get(
                    backendUrls.getMessageThreadList,
                    {
                        recent: $(this).val()
                    })
                    .done(function (html) {
                        messageThreads.html(html);
                    })
                    .always(function () {
                        listSkeleton.hide();
                        messageThreads.show();
                    });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);